import React from 'react';
import bemBlock from '@gik/core/utils/bemBlock';
import { PropsWithClassName } from '@gik/core/utils/ReactUtils';
import { FormField, FieldSet } from '@gik/ui/Form';

export interface IPageTitleFieldSetProps {}

export interface PageTitleValues {
  pageTitle: string;
}

export const PageTitleFieldSetBlockName = 'page-title-fieldset';

const PageTitleFieldSet: React.FC<PropsWithClassName<IPageTitleFieldSetProps>> = ({ className }): JSX.Element => {
  const bem = bemBlock(PageTitleFieldSetBlockName);

  return (
    <FieldSet className={bem(null, null, className)}>
      <FormField name="pageTitle" />
    </FieldSet>
  );
};

export default PageTitleFieldSet;

export { default as pageTitleFieldSetSchema } from './pageTitleFieldSetSchema';
